/** A preview nobody presses for half an hour goes back to the lobby (ADR-058). */
export const BEKIJKEN_IDLE_MS = 30 * 60_000;

/** Fires `onIdle` once, `ms` after the last `touch`; `stop` for good. */
export class IdleTimer {
  #handle: ReturnType<typeof setTimeout> | undefined;

  constructor(
    private readonly ms: number,
    private readonly onIdle: () => void,
  ) {}

  touch(): void {
    this.stop();
    this.#handle = setTimeout(() => {
      this.#handle = undefined;
      this.onIdle();
    }, this.ms);
  }

  stop(): void {
    if (this.#handle !== undefined) clearTimeout(this.#handle);
    this.#handle = undefined;
  }
}
